/* jshint -W086 */
/**
 * Controller for managing expandable containers.
 * This class handles the logic for expanding and collapsing containers,
 * as well as managing their dimensions and styles.
 */
class ExpandableContainerController {
    /**
     * Constructor for ExpandableContainerController.
     * @param {Object} $scope - AngularJS scope.
     * @param {Object} $rootScope - AngularJS root scope.
     * @param {Object} $config - Configuration object.
     */
    constructor($scope, $rootScope, $config) {
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.$config = $config;

        this.fullIconCls = "resize-full";
        this.smallIconCls = "resize-small";
        this.deactiveClick = false;
        this.originWidth = null;
        this.originHeight = null;

        // Bind the onExpandableContainer method to this instance
        this.$scope.onExpandableContainer = this.onExpandableContainer.bind(this);
    }

    /**
     * Expands the given element to full size.
     * @param {jQuery} element - The element to expand.
     */
    full(element) {
        const parentMarginLeft = parseInt(element.parents(".col-element").css("margin-left").replace("px", ""), 10);
        const parentWidth = element.parents(".row-element").outerWidth() - parentMarginLeft;
        const parentHeight = element.parents(".row-element").outerHeight();

        this.originWidth = element.width();
        this.originHeight = element.innerHeight();

        let newWidth = this.getNewWidth(parentWidth, this.originWidth, this.$scope.expandableWidth);
        const newHeight = this.$scope.expandableWidth;

        if (this.$scope.colPosition === "0") {
            if (isCMS && !this.$config.isPreviewMode()) {
                newWidth += (2 * parentMarginLeft);
            } else {
                newWidth += (parentMarginLeft);
            }
            element.animate({
                width: newWidth,
            }, 1000, () => {
                this.deactiveClick = false;
                this.$rootScope.$broadcast('tableObject_render');
            });
        } else {
            if (isCMS && !this.$config.isPreviewMode()) {
                newWidth += (2 * parentMarginLeft);
            } else {
                newWidth += (parentMarginLeft);
            }
            element.animate({
                left: this.originWidth - newWidth,
                width: newWidth,
            }, 1000, () => {
                this.deactiveClick = false;
                this.$rootScope.$broadcast('tableObject_render');
            });
        }
    }

    /**
     * Collapses the given element to its original size.
     * @param {jQuery} element - The element to collapse.
     */
    small(element) {
        element.animate({
            width: this.originWidth,
            left: 0
        }, 1000, () => {
            element.removeClass("container-expanded");
            element.removeAttr("style");
            this.deactiveClick = false;
            this.$rootScope.$broadcast('tableObject_render');
        });
    }

    /**
     * Calculates the new width for the element based on parent dimensions and expandable value.
     * @param {number} parentWidth - The width of the parent element.
     * @param {number} originWidth - The original width of the element.
     * @param {number} expandableValue - The expandable value.
     * @returns {number} The new width.
     */
    getNewWidth(parentWidth, originWidth, expandableValue) {
        let width = (originWidth * expandableValue / 100) + originWidth;

        if (width > parentWidth) {
            width = parentWidth;
        }
        return width;
    }

    /**
     * Closes all expanded containers.
     */
    closeAllExpandedContainer() {
        $("." + this.smallIconCls).addClass(this.fullIconCls).removeClass(this.smallIconCls);
        $(".container-expanded").each((key, element) => {
            $(element).finish();
            $(element).removeClass("container-expanded");
            $(element).removeAttr("style");
        });
    }

    /**
     * Handles the expandable container click event.
     * @param {Event} e - The click event.
     */
    onExpandableContainer(e) {
        if (!this.deactiveClick) {
            this.deactiveClick = true;

            if ($("." + this.$scope.expandableElementClass).hasClass("container-expanded")) {
                $(e.currentTarget).removeClass(this.smallIconCls).addClass(this.fullIconCls);
                this.small($("." + this.$scope.expandableElementClass));
            } else {
                this.closeAllExpandedContainer();

                $("." + this.$scope.expandableElementClass).addClass("container-expanded");
                $(e.currentTarget).removeClass(this.fullIconCls).addClass(this.smallIconCls);

                this.full($("." + this.$scope.expandableElementClass));
            }
        }
    }
}

export default ExpandableContainerController;